import Button, {BTN_TYPES} from '@/ui/Button';
import styles from './styles.module.scss';

interface IAdditionalActionProps {
    text: string;
    btnText: string;
    onClick: () => void;
}

const AdditionalAction = ({text = '', btnText = '', onClick = () => {}}: IAdditionalActionProps) => {
    return (
        <div className={styles.additional}>
            {text}
            <Button
                btnType={BTN_TYPES.opacity}
                onClick={onClick}
                btnProps={{type: 'button'}}
                btnStyles={[styles.flatBtn]}
            >
                {btnText}
            </Button>
        </div>
    );
};

export default AdditionalAction;
